import { render } from "./AddSvg.vue?vue&type=template&id=72791ae2&bindings={}"
import script from "./AddSvg.vue?vue&type=script&lang=ts"
export * from "./AddSvg.vue?vue&type=script&lang=ts"
script.render = render

export default script